
import { useEffect } from 'react';
import { Row, Button, Card, Col } from '../../ui/ot';
import NewSelf from '../../news/views/New';


const New = ({ prefixTitle }) => {
  useEffect(() => {
    document.title = `${prefixTitle} | 最新消息`;
  }, [prefixTitle]);

  return (
    <Row gutter={[8, 8]}
      justify={'center'}
      align={'middle'}
      style={{
        padding: "1rem"
      }}>
      <Col span={24}>
        <NewSelf

        ></NewSelf>
      </Col>
    </Row>
  );
};

export default New;
